import axios from "../../axios";

const getAppliedPayments = async (payment_id) => {
  try {
    const { data } = await axios.get(`/vendor_payments/applied/${payment_id}`);
    console.log(data, "data");
    return data;
  } catch (e) {
    throw e;
  }
};

const processPayment = async ({ packet }) => {
  console.log(packet, "packet");
  let url = "/vendor_payments";
  try {
    const { data } = await axios.post(`${url}`, { ...packet });
    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

const applyPaymentsToInvoice = async (dataPacket) => {
  try {
    const { data } = await axios.post(`/vendor_payments/apply`, dataPacket);
    return data;
  } catch (e) {
    throw e;
  }
}

const removeAppliedPayment = async (applied_vendor_payment_id) => {
  try {
    const { data } = await axios.delete(`/vendor_payments/applied/${applied_vendor_payment_id}`);
    return data;
  } catch (e) {
    throw e;
  }
};

export { processPayment, getAppliedPayments, applyPaymentsToInvoice, removeAppliedPayment };